/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
  $(function(){
    $('.slideshow-main').slick({
      infinite: true,
      dots:true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      nextArrow: $('#next-slide'),
      prevArrow: $('#prev-slide'),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            dots: false
          }
        } 
      ]
  	   
    });
    $('.slide-content').slick({
      infinite: true,
      dots:false,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      arrows: true,
      nextArrow: $('#next'),
      prevArrow: $('#prev'),
  	  autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });